module.exports = __webpack_public_path__ + "img/avatar4.d3d4ff7f.png";